var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex" },
    [
      _c("el-input", {
        attrs: { placeholder: "ENTER NEW GROUP NAME" },
        model: {
          value: _vm.name,
          callback: function ($$v) {
            _vm.name = $$v
          },
          expression: "name",
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-purple ml-2", on: { click: _vm.create } },
        [_vm._v("CREATE")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }